export const SERVER_FETCH_ERROR_PREFIX = 'server_code';
export const EMPTY_VAST_ERROR_PREFIX = 'empty_vast';
export const CLIENT_FETCH_ERROR_PREFIX = 'client_code';

export default class VASTError extends Error {
  code: number;
  e_fetch_error: string | undefined = undefined;
  additionalTrace: any;

  constructor(code: number, message: string, e_fetch_error?: string) {
    super(message);

    Object.setPrototypeOf(this, VASTError.prototype);

    this.code = code;
    if (e_fetch_error) {
      this.e_fetch_error = e_fetch_error;
    }
  }
}
